'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

require('../../styles/sections/index-icons.scss');

exports.default = (0, _themeSections.register)('index-icons', {
  onLoad: function onLoad() {},
  onUnload: function onUnload() {}
});